import status from './status'
import TransitionToCancelModal from '../../components/TransitionToCancelModal'

/**
 * NOTE:
 * to add additional POST body payload,
 * use additionalPayload key, all the properties
 * will be merged with the default payload
 * Dikonfirmasi: [
 *   {
 *     status: status.CANCELLED,
 *     customModalTransition: TransitionToCancelModal,
 *   },
 * ],
 */

const statusTransitions = {
  /* DRAFT */
  Draf: [
    {
      status: status.WAITING_FOR_APPROVAL,
    },
    {
      status: status.SCHEDULED,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModal,
    },
  ],

  /* SCHEDULED */
  Dijadwalkan: [
    {
      status: status.STARTED,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModal,
    },
  ],

  /* APPROVED */
  Disetujui: [
    {
      status: status.SCHEDULED,
    },
  ],

  /* STARTED */
  Perjalanan: [
    {
      status: status.ENDED,
    },
  ],

  /* ENDED */
  Selesai: [],

  /* CANCELED */
  Dibatalkan: [],

  /* REJECTED_BY_VENDOR */
  Ditolak: [
    {
      status: status.WAITING_FOR_VENDOR,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModal,
    },
  ],

  isFromVendorRequest: [
    {
      status: status.SCHEDULED,
    },
  ],

  hasVendorDraft: [
    {
      status: status.WAITING_FOR_VENDOR,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModal,
    },
  ],

  hasVendor: [],
}

export default statusTransitions
